import type { RecoSliderPosition } from 'common/enums/RecommendationsSlider';
import { getConfig } from '../../utils';
import { useSlideSize } from '../slideSize';

interface UseRecoSliderConfigParams {
  position: RecoSliderPosition;
  withBackground?: boolean;
  isObserved: boolean;
  isSmallVariant?: boolean;
}

export const useSliderConfig = ({
  position,
  withBackground,
  isObserved,
  isSmallVariant = false,
}: UseRecoSliderConfigParams) => {
  const config = getConfig(position, withBackground, isSmallVariant);
  const slideSize = useSlideSize(config);

  return { ...slideSize, isObserved, widthConfig: config.width, gapConfig: config.gap };
};
